import React from "react";
import { Grid, Typography, Select, MenuItem, FormControl } from "@mui/material";
import Pagination from "@mui/material/Pagination";

const CustomPagination = ({
  count,
  totalPage,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = totalPage ?? Math.ceil(count / rowsPerPage);

  const handlePageChange = (event, value) => {
    onPageChange(event, value - 1); // Material-UI Pagination uses 1-based index, convert it to 0-based
  };

  const handleRowsPerPageChange = (event) => {
    onRowsPerPageChange(event);
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: "auto" }}
    >
      <Grid
        item
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="contained">Rows per page</Typography>
        <FormControl sx={{ m: 1 }}>
          <Select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            size="small"
            sx={{ "& .MuiSelect-select": { py: 0.75, px: 1.25 } }}
          >
            {[5, 10, 25, 50, 100].map((pageSize) => (
              <MenuItem key={pageSize} value={pageSize}>
                {pageSize}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item sx={{ mt: { xs: 2, sm: 0 } }}>
        <Pagination
          count={totalPages}
          page={page + 1} // Convert 0-based page to 1-based for Material-UI Pagination
          onChange={handlePageChange}
          variant="outlined"
          shape="rounded"
          showFirstButton
          showLastButton
          sx={{
            "& .MuiButtonBase-root": {
              borderRadius: "50%",
              cursor: "pointer",
            },
            "& .MuiPaginationItem-root.Mui-selected": {
              backgroundImage: "linear-gradient(90deg, #00BB9F, #B0EE93)", // Changed backgroundColor to backgroundImage for linear gradient
              color: "#ffffff",
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default CustomPagination;
